import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const SystemAlert = ({ alert }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  const getAlertStyles = (severity) => {
    switch (severity) {
      case 'info':
        return {
          bg: 'bg-primary/10',
          border: 'border-primary/20',
          text: 'text-primary',
          icon: 'Info'
        };
      case 'warning':
        return {
          bg: 'bg-warning/10',
          border: 'border-warning/20',
          text: 'text-warning',
          icon: 'AlertTriangle'
        };
      case 'error':
        return {
          bg: 'bg-error/10',
          border: 'border-error/20',
          text: 'text-error',
          icon: 'AlertCircle'
        };
      case 'success':
        return {
          bg: 'bg-success/10',
          border: 'border-success/20',
          text: 'text-success',
          icon: 'CheckCircle'
        };
      default:
        return {
          bg: 'bg-muted',
          border: 'border-border',
          text: 'text-foreground',
          icon: 'Bell'
        };
    }
  };

  if (isDismissed) return null;

  const styles = getAlertStyles(alert?.severity);

  return (
    <div className={`${styles?.bg} ${styles?.border} border rounded-lg p-4 transition-all duration-250`}>
      <div className="flex items-start gap-3">
        <Icon name={styles?.icon} size={20} className={styles?.text} />
        <div className="flex-1 min-w-0">
          <h4 className={`text-sm font-semibold ${styles?.text} mb-1`}>{alert?.title}</h4>
          <p className="text-sm text-muted-foreground">{alert?.message}</p>
        </div>
        <button
          onClick={() => setIsDismissed(true)}
          className="flex-shrink-0 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Dismiss alert"
        >
          <Icon name="X" size={18} />
        </button>
      </div>
    </div>
  );
};

export default SystemAlert;